import { createStore } from 'vuex'
import login from './modules/login'
import router from './modules/router'
import user from './modules/user'
import list from './modules/list'
import lot from './modules/lot'
import initialLoading from './modules/initialLoading'
import newVisit from './modules/newVisit'
import attribution from './modules/attribution'
import mutation from './modules/mutation'
import timeline from './modules/timeline'
import visit from './modules/visit'
import imageViewer from './modules/imageViewer'
import cameraViewer from './modules/cameraViewer'
import metrics from './modules/metrics'
import obsolescenceFlags from './modules/obsolescenceFlags'
import actionsAndWorks from './modules/actionsAndWorks'
import exportVisit from './modules/exportVisit'
import properties from './modules/properties'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  state: {
    // État global de l'application
  },
  mutations: {
    INIT() {
      // Initialisation globale
    },
    SEND_MUTATION(_state, _payload) {
      // Gestion des mutations globales
    },
    REGISTER_MUTATION(_state, _payload) {
      // Enregistrement des mutations
    },
  },
  actions: {
    init({ commit }) {
      commit('INIT')
    },
    initializeApp({ dispatch }) {
      // Action d'initialisation globale
      dispatch('init')
    },
    sendMutation({ commit }, payload) {
      commit('SEND_MUTATION', payload)
    },
    registerMutation({ commit }, payload) {
      commit('REGISTER_MUTATION', payload)
    },
  },
  modules: {
    login,
    router,
    user,
    list,
    lot,
    initialLoading,
    newVisit,
    attribution,
    mutation,
    timeline,
    visit,
    imageViewer,
    cameraViewer,
    metrics,
    obsolescenceFlags,
    actionsAndWorks,
    exportVisit,
    properties
  },
  strict: debug
})
